import { useContext, useEffect } from 'react'
import { RouterProvider, createMemoryRouter, RouteObject } from 'react-router-dom'
import { AuthenticationContext } from '../../AuthenticationContext'
import CostCodes from "../../components/SystemSetup/CostCodes/CostCodes"
import CrewMembers from "../../components/SystemSetup/CrewMembers/CrewMembers"
import Divisions from "../../components/SystemSetup/Divisions/Divisions"
import ItemCategoriesForm from "../../components/SystemSetup/ItemCategories/ItemCategoriesForm"
import SalesLeadsForm from "../../components/SystemSetup/SalesLeads/SalesLeadsForm"
import EmailTemplateList from "../../components/EmailTemplates/EmailTemplateList"
import ImportExport from "../../components/SystemSetup/ImportExport/ImportExport"
import QuickBooksIntegrationPage from "../../components/SystemSetup/QuickBooks/QuickBooksIntegrationPage"
import ZapierApiKeys from "../../components/Setup/ZapierApiKeys/ZapierApiKeys"
import BudgetCalculatorWrapper from "../../components/BudgetCalculator/BudgetCalculatorWrapper"
import BudgetFormWrapper from "../../components/Budgets/BudgetFormWrapper"
import SetupRoot from './SetupRoot'
import SplashPage from './SplashPage'
import { SetupContextWrapper } from './SetupContext'
import { canAccessSetup } from './setupPageModel'
import UnbillableCategories from '../../components/SystemSetup/UnbillableCategories/UnbillableCategories'
import JobNumbering from '../../components/SystemSetup/JobNumbering/JobNumbering'

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SetupRoot />,
    children: [
      {
        path: '/',
        element: <SplashPage />,
        handle: {
          showHero: false
        }
      },
      {
        path: '/budgets/:year',
        element: <BudgetFormWrapper />,
        handle: {
          title: ({ year }: { year: number }) => {
            return `${year} Budget`
          },
          showSaveButton: true
        }
      },
      {
        path: '/budget-worksheets',
        element: <BudgetCalculatorWrapper />,
        handle: {
          title: 'Budget Worksheets'
        }
      },
      {
        path: '/divisions',
        element: <Divisions />,
        handle: {
          title: 'Divisions'
        }
      },
      {
        path: '/crew-members',
        element: <CrewMembers />,
        handle: {
          title: 'Crew Members'
        }
      },
      {
        path: '/cost-codes',
        element: <CostCodes />,
        handle: {
          title: 'Cost Codes'
        }
      },
      {
        path: '/item-categories',
        element: <ItemCategoriesForm />,
        handle: {
          title: 'Item Categories'
        }
      },
      {
        path: '/sales-leads',
        element: <SalesLeadsForm />,
        handle: {
          title: 'Sales Leads'
        }
      },
      {
        path: '/email-templates',
        element: <EmailTemplateList />,
        handle: {
          title: 'Email Templates'
        }
      },
      {
        path: '/unbillable-categories',
        element: <UnbillableCategories />,
        handle: {
          title: 'Unbillable Categories'
        }
      },
      {
        path: '/job-numbering',
        element: <JobNumbering />,
        handle: {
          title: 'Job Numbering'
        }
      },
      {
        path: '/import-export',
        element: <ImportExport />,
        handle: {
          title: 'Import & Export'
        }
      },
      {
        path: '/quickbooks',
        element: <QuickBooksIntegrationPage />,
        handle: {
          title: 'QuickBooks'
        }
      },
      {
        path: '/zapier-api-keys',
        element: <ZapierApiKeys />,
        handle: {
          title: 'Zapier API Keys'
        }
      }
    ]
  },
]

const setupRouter = createMemoryRouter(routes, {
  initialEntries: ['/'],
})

const SetupPage = () => {
  const { currentUser } = useContext(AuthenticationContext)

  useEffect(() => {
    if (currentUser && !canAccessSetup(currentUser)) {
      window.location.href = '/'
    }
  }, [currentUser])

  if (!canAccessSetup(currentUser)) {
    return null
  }

  return <SetupContextWrapper>
    <RouterProvider router={setupRouter} />
  </SetupContextWrapper>
}

export default SetupPage
